/* Shared form handling for the HBCU Band Challenge pages.
   Submissions are POSTed as JSON to a Zapier Catch Hook, which fans out to
   the Google Sheet and the notification emails. Set the URLs below. */

window.HBCU_CONFIG = window.HBCU_CONFIG || {};

/* Zapier Catch Hooks.
   Every payload carries a "form" field of either "registration" or
   "submission", so you can confirm in Zapier which hook is which. */
window.HBCU_CONFIG.registrationWebhook =
  'https://hooks.zapier.com/hooks/catch/3151844/4dln04x/';
window.HBCU_CONFIG.submissionWebhook =
  'https://hooks.zapier.com/hooks/catch/3151844/4dlnpvs/';

/* Registration and entry deadline. Both forms close themselves after this
   moment and show the closed message instead. America/New_York, 23:59. */
window.HBCU_CONFIG.deadline = window.HBCU_CONFIG.deadline || '2026-11-12T23:59:00-05:00';

(function () {
  'use strict';

  /* ---- HBCU school dropdown ---------------------------------------- */
  function fillSchools() {
    var selects = document.querySelectorAll('select[data-schools]');
    if (!selects.length || !window.HBCU_SCHOOLS) return;
    selects.forEach(function (sel) {
      var frag = document.createDocumentFragment();
      window.HBCU_SCHOOLS.forEach(function (group) {
        var og = document.createElement('optgroup');
        og.label = group.state;
        group.schools.forEach(function (name) {
          var o = document.createElement('option');
          o.value = name; o.textContent = name;
          og.appendChild(o);
        });
        frag.appendChild(og);
      });
      sel.appendChild(frag);
    });
  }

  /* ---- US states ---------------------------------------------------- */
  var STATES = ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','U.S. Virgin Islands','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'];
  function fillStates() {
    document.querySelectorAll('select[data-states]').forEach(function (sel) {
      STATES.forEach(function (s) {
        var o = document.createElement('option');
        o.value = s; o.textContent = s;
        sel.appendChild(o);
      });
    });
  }

  /* ---- "My School Is Not Listed" free-text fallback ------------------ */
  function schoolFallback() {
    document.querySelectorAll('select[data-schools]').forEach(function (sel) {
      var other = document.querySelector('[data-school-other]');
      if (!other) return;
      sel.addEventListener('change', function () {
        var show = sel.value === 'My School Is Not Listed';
        other.hidden = !show;
        other.querySelector('input').required = show;
      });
    });
  }

  /* ---- Reference number --------------------------------------------- */
  function refNumber(prefix) {
    var t = Date.now().toString(36).toUpperCase();
    var r = Math.random().toString(36).slice(2, 6).toUpperCase();
    return prefix + '-' + t.slice(-5) + r;
  }

  /* ---- Submit ------------------------------------------------------- */
  function wireForms() {
    document.querySelectorAll('form[data-hbcu-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.reportValidity()) return;

        var kind = form.getAttribute('data-hbcu-form');
        var hook = kind === 'submission'
          ? window.HBCU_CONFIG.submissionWebhook
          : window.HBCU_CONFIG.registrationWebhook;

        // Honeypot — hidden from people, irresistible to bots.
        var trap = form.querySelector('[name=website]');
        if (trap && trap.value) { console.warn('[HBCU] honeypot tripped'); return; }

        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = v; });
        delete data.website;
        data.form = kind;
        data.reference = refNumber(kind === 'submission' ? 'ENT' : 'REG');
        data.submitted_at = new Date().toISOString();
        data.page = window.location.href;

        var btn = form.querySelector('[type=submit]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

        var done = function () {
          var name = data.band_name || data.school || '';
          var target = form.getAttribute('data-success') || '/';
          var join = target.indexOf('?') === -1 ? '?' : '&';
          window.location.href = target + join +
            'ref=' + encodeURIComponent(data.reference) +
            '&name=' + encodeURIComponent(name);
        };

        if (!hook || hook.indexOf('REPLACE_WITH') === 0) {
          console.warn('[HBCU] No Zapier hook configured — skipping POST.', data);
          done();
          return;
        }

        fetch(hook, {
          method: 'POST',
          mode: 'no-cors',                       // Zapier hooks do not send CORS headers
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(data)
        }).then(done).catch(function (err) {
          console.error(err);
          if (btn) { btn.disabled = false; btn.textContent = label; }
          alert('Sorry — we could not send your form. Please try again, or email info@davidbanner.com.');
        });
      });
    });
  }

  /* ---- Confirmation page tokens -------------------------------------- */
  function fillConfirmation() {
    var p = new URLSearchParams(window.location.search);
    var name = p.get('name');
    var ref = p.get('ref');
    document.querySelectorAll('[data-token-name]').forEach(function (el) {
      el.textContent = name || 'your band';
    });
    var refEl = document.querySelector('[data-token-ref]');
    if (refEl) {
      if (ref) { refEl.textContent = ref; }
      else { var box = refEl.closest('[data-ref-box]'); if (box) box.hidden = true; }
    }
  }

  /* ---- Automatic deadline closure ------------------------------------ */
  function enforceDeadline() {
    var d = window.HBCU_CONFIG.deadline;
    if (!d) return;
    var closes = new Date(d);
    if (isNaN(closes) || Date.now() < closes.getTime()) return;

    document.querySelectorAll('[data-closes]').forEach(function (el) {
      el.hidden = true;
    });
    document.querySelectorAll('[data-closed-message]').forEach(function (el) {
      el.hidden = false;
    });
  }


  /* ---- Key dates: mobile slider ---------------------------------------
     Desktop keeps the plain grid. Below the breakpoint the track becomes a
     scroll-snap carousel with peeking neighbours, arrows and dots. Native
     scrolling does the swiping; the arrows drive a tracked index so rapid
     clicks never get lost while a smooth scroll is still running. */
  function datesSlider() {
    document.querySelectorAll('[data-dates-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('.dates');
      var cards = Array.prototype.slice.call(track.querySelectorAll('.date'));
      var prev  = wrap.querySelector('.dates__arrow--prev');
      var next  = wrap.querySelector('.dates__arrow--next');
      var dots  = wrap.querySelector('.dates__dots');
      if (!cards.length || !track) return;

      var index = 0;
      var settleAt = 0;          // ignore scroll-derived index until this time

      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dates__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Date ' + (i + 1) + ' of ' + cards.length);
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      });

      function isSlider() {
        return window.getComputedStyle(track).overflowX !== 'visible';
      }

      // Centre of a card within the track's scrollable width. Rect-based:
      // offsetLeft is relative to .dates-wrap, not the scroller.
      function centreOf(c) {
        var tr = track.getBoundingClientRect();
        var cr = c.getBoundingClientRect();
        return (cr.left - tr.left) + track.scrollLeft + cr.width / 2;
      }

      function nearest() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestGap = Infinity;
        cards.forEach(function (c, i) {
          var gap = Math.abs(centreOf(c) - mid);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      }

      function paint() {
        cards.forEach(function (c, n) { c.classList.toggle('is-current', n === index); });
        Array.prototype.forEach.call(dots.children, function (d, n) {
          d.classList.toggle('is-on', n === index);
          d.setAttribute('aria-selected', n === index ? 'true' : 'false');
        });
        prev.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      }

      function go(i, instant) {
        index = Math.max(0, Math.min(cards.length - 1, i));
        var left = centreOf(cards[index]) - track.clientWidth / 2;
        if (instant) {
          track.scrollLeft = left;
        } else {
          settleAt = Date.now() + 700;
          track.scrollTo({ left: left, behavior: 'smooth' });
        }
        paint();
      }

      function showControls() {
        var on = isSlider();
        [prev, next, dots].forEach(function (el) { if (el) el.hidden = !on; });
        return on;
      }

      prev.addEventListener('click', function () { go(index - 1); });
      next.addEventListener('click', function () { go(index + 1); });

      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          if (Date.now() < settleAt) return;   // still animating from a click
          index = nearest();
          paint();
        }, 80);
      }, { passive: true });

      window.addEventListener('resize', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          if (showControls()) go(index, true);
        }, 150);
      });

      if (showControls()) go(0, true);
    });
  }

  /* ---- Automatic deadline closure ------------------------------------ */
  function enforceDeadline() {
    var d = window.HBCU_CONFIG.deadline;
    if (!d) return;
    var closes = new Date(d);
    if (isNaN(closes) || Date.now() < closes.getTime()) return;

    document.querySelectorAll('[data-closes]').forEach(function (el) {
      el.hidden = true;
    });
    document.querySelectorAll('[data-closed-message]').forEach(function (el) {
      el.hidden = false;
    });
  }


  /* ---- Key dates: mobile slider ---------------------------------------
     Desktop keeps the plain grid. Below the breakpoint the track becomes a
     scroll-snap carousel with peeking neighbours, arrows and dots. Driven by
     native scrolling so a real swipe works without any touch handling. */
  function datesSlider() {
    var wraps = document.querySelectorAll('[data-dates-slider]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('.dates');
      var cards = Array.prototype.slice.call(track.querySelectorAll('.date'));
      var prev  = wrap.querySelector('.dates__arrow--prev');
      var next  = wrap.querySelector('.dates__arrow--next');
      var dots  = wrap.querySelector('.dates__dots');
      if (!cards.length) return;

      // build the dots once
      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dates__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Date ' + (i + 1) + ' of ' + cards.length);
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      });

      function isSlider() {
        return window.getComputedStyle(track).overflowX !== 'visible';
      }

      // Position of a card's centre within the track's scrollable width.
      // Measured off rects rather than offsetLeft, which is relative to the
      // nearest positioned ancestor (.dates-wrap) and not the scroller.
      function centreOf(c) {
        var tr = track.getBoundingClientRect();
        var cr = c.getBoundingClientRect();
        return (cr.left - tr.left) + track.scrollLeft + cr.width / 2;
      }

      function current() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestGap = Infinity;
        cards.forEach(function (c, i) {
          var gap = Math.abs(centreOf(c) - mid);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      }

      // The arrows step this rather than re-reading the scroll position, so
      // rapid clicks don't lose steps while a smooth scroll is still running.
      var index = 0;

      function go(i) {
        index = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({
          left: centreOf(cards[index]) - track.clientWidth / 2,
          behavior: 'smooth'
        });
        paint();
      }

      function paint() {
        cards.forEach(function (c, n) { c.classList.toggle('is-current', n === index); });
        Array.prototype.forEach.call(dots.children, function (d, n) {
          d.classList.toggle('is-on', n === index);
          d.setAttribute('aria-selected', n === index ? 'true' : 'false');
        });
        prev.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      }

      function sync() {
        var on = isSlider();
        [prev, next, dots].forEach(function (el) { if (el) el.hidden = !on; });
        if (!on) return;
        index = current();
        var i = index;
        cards.forEach(function (c, n) { c.classList.toggle('is-current', n === i); });
        Array.prototype.forEach.call(dots.children, function (d, n) {
          d.classList.toggle('is-on', n === i);
          d.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
        prev.disabled = i === 0;
        next.disabled = i === cards.length - 1;
      }

      prev.addEventListener('click', function () { go(index - 1); });
      next.addEventListener('click', function () { go(index + 1); });

      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(sync, 60);
      }, { passive: true });
      window.addEventListener('resize', function () {
        clearTimeout(tick);
        tick = setTimeout(sync, 120);
      });

      sync();
      // open on the first date, centred, without animating on load
      if (isSlider()) {
        track.scrollLeft = centreOf(cards[0]) - track.clientWidth / 2;
        sync();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enforceDeadline();
    datesSlider();
    fillSchools();
    fillStates();
    schoolFallback();
    wireForms();
    fillConfirmation();
  });
})();
